var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('input',{attrs:{"type":_vm.contents.type,"multiple":_vm.contents.multiple,"placeholder":_vm.contents.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.processValue}}),_c('span',[_vm._v(_vm._s(_vm.contents.label)+" é obrigatório")])])
}
var staticRenderFns = []

export { render, staticRenderFns }